// ==================================================================================================
//  TECH DEBT: THIS CODE WAS TAKEN FROM https://github.com/tombolaltd/javascript-arcade
//             AND SHOULD BE REPLACED WITH A SUITABLE NPM PACKAGE ONCE AVAILABLE
// ==================================================================================================
import { Texture, Text, TextStyle } from 'pixi.js';
import { TweenLite } from 'gsap';
import { SlideManager, Slide, SliderControl } from '@/components/arcade-game/_components/how-to-play/_domain/slider';
import { HowToPlaySlide } from '@/components/arcade-game/_components/how-to-play/_domain/animations/htp-slide';

const TEXT_STYLE: TextStyle = new TextStyle({
    fontSize: 24,
    fill: '#1DBBAC'
});
const BASE_HEIGHT = 640;
const BASE_WIDTH = 1136;

class HowToPlayAnimations extends SlideManager {
  private slideWidth: number;
  private slideHeight: number;
  private title: Text;

  constructor(slides: Slide[], slideControlAssets: {enabled: Texture, disabled: Texture}, dimensions: {width: number, height: number}) {
    super(slides);

    this.slideWidth = dimensions.width;
    this.slideHeight = dimensions.height;

    this.title = new Text('how to play', TEXT_STYLE);
    this.title.anchor.set(0.5);
    this.addChild(this.title);

    (this.slides as HowToPlaySlide[]).forEach((slide, index) => {
        const enabled = index === 0;

        this.addChild(slide);
        slide.setCallbacks(this.transitionSlideIn, this.transitionSlideLeft, index)
        .then(() => {
            slide.initSlide();
        });

        if (enabled) {
            slide.play();
        }

        const control = new SliderControl(slideControlAssets, enabled, this.changeSlide, this.transitionSlideIn, index);
        this.controlsContainer.addChild(control);
    });

    this.addChild(this.swipeRegion);
    this.addChild(this.controlsContainer);

    this.handleOrientationChange(dimensions.width, dimensions.height);
  }

  protected transitionSlideLeft(isAutoPlayTransition: boolean = false, goToLastSlide: boolean = false): void {
    const currentSlide = (this.slides as HowToPlaySlide[])[this.currentSlideIndex];

    currentSlide.animation.update(0);
    currentSlide.animation.skeleton.setToSetupPose();
    currentSlide.animation.state.clearTrack(currentSlide.slideIndex);

    super.transitionSlideLeft(isAutoPlayTransition, goToLastSlide);
  }

  protected transitionSlideRight(isAutoPlayTransition: boolean = false, goToFirstSlide: boolean = false): void {
    const currentSlide = (this.slides as HowToPlaySlide[])[this.currentSlideIndex];

    currentSlide.animation.update(0);
    currentSlide.animation.skeleton.setToSetupPose();
    currentSlide.animation.state.clearTrack(currentSlide.slideIndex);

    super.transitionSlideRight(isAutoPlayTransition, goToFirstSlide);
  }

  protected transitionSlideIn(isAutoPlayTransition: boolean = false): void {
    const duration = isAutoPlayTransition ? this.autoPlayTransitionDuration : this.transitionDuration;

    this.updateControls();

    TweenLite.to(this.slides[this.currentSlideIndex].position, duration, {
      x: this.slideInPosition,
      onComplete: () => {
        (this.slides as HowToPlaySlide[])[this.currentSlideIndex].play();
      }
    });
  }

  public handleOrientationChange(viewportWidth: number, viewportHeight: number) {
    const halfViewportWidth = viewportWidth * 0.5;
    const heightScale = viewportHeight / BASE_HEIGHT;
    const widthScale = viewportWidth / BASE_WIDTH;
    const isPortrait = viewportHeight >= viewportWidth;

    const scale = (heightScale > widthScale ? widthScale : heightScale);

    this.title.style.fontSize = BASE_HEIGHT * 0.15;
    this.title.scale.set(scale);
    this.title.position.x = halfViewportWidth;
    this.title.position.y = isPortrait ? viewportHeight * 0.4 - (this.title.height * 1.5) : this.title.height * 0.5;

    this.swipeRegion.width = viewportWidth;
    this.swipeRegion.height = viewportHeight;

    this.slideWidth = BASE_WIDTH;
    this.slideHeight = BASE_HEIGHT * 0.5;

    this.slideOutPosition = viewportWidth * 2;
    this.slideInPosition = halfViewportWidth;

    this.slides.forEach((slide) => {
      slide.handleOrientationChange(this.slideWidth, this.slideHeight, viewportHeight * 0.5);
      slide.position.x = this.slideOutPosition;
      slide.scale.set(scale);
    });

    this.swipeThreshold = this.slides[this.currentSlideIndex].width * 0.25;

    this.slides[this.currentSlideIndex].position.x = this.slideInPosition;

    (this.controlsContainer.children as SliderControl[]).forEach((control, index) => {
      control.handleOrientationChange(BASE_HEIGHT * 0.1, index);
    });

    this.controlsContainer.scale.set(scale);
    this.controlsContainer.position.x = halfViewportWidth - (this.controlsContainer.width * 0.5);
    this.controlsContainer.position.y = viewportHeight - (this.controlsContainer.height * 1.2);
  }
}

export { HowToPlayAnimations };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/arcade-game/_components/how-to-play/_domain/animations/htp-animations.ts